export default class Zone {
  constructor(json) {
    this.json = json
  }
}
